<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="userActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheUserActivityPage',
  computed: { ...mapGetters({ userActivity: 'user/getUserActivities' }) },
  methods: { ...mapActions({ fetch: 'user/fetchUserActivitiesByUserID' }) },
  beforeMount() {
    this.fetch({ user_id: this.$route.params.id })
  }
}
</script>
